// extracted by mini-css-extract-plugin
module.exports = {"container":"shippingInContainer_container__1Cgjt"};